define('ch_site_notification',[
    "jquery"
], function($) {
    $(function(){
        $('.js-close-notification').on('click', function(e) {
            e.preventDefault();

            $(this).parent().slideUp(200, function() {
                var date = new Date();
                var expires;
                var $filterNavigation = $("#filter-navigation");

                date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
                document.cookie = CH.cookieName + "_status=0;" + expires + "; path=/";

                if ($filterNavigation.length > 0) {
                    window.filterBarOffset = $filterNavigation.offset().top;
                }
            });
        });
    });
});

